"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberValueEditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _ValidValuesHeader = require("../../shared/ValidValuesHeader");

var _ValidationResultDisplay = require("../../shared/ValidationResultDisplay");

var _options = require("../../shared/enums/options");

var _propTypes2 = require("../../shared/propTypes");

var _messages = _interopRequireDefault(require("./messages"));

var _numberValidators = require("../../shared/validators/numberValidators");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var validateValue = function validateValue(value) {
  if (!value) {
    throw new Error('NumberValueEditor did not receive a value');
  } else if (value.type && value.type !== _options.VALUE) {
    throw new Error('NumberValueEditor received a value with a incorrect value type');
  }
};

var NumberValueEditor = function NumberValueEditor(_ref) {
  var value = _ref.value,
      attribute = _ref.attribute,
      onValueChanged = _ref.onValueChanged,
      enforceValidValues = _ref.enforceValidValues;
  (0, _react.useEffect)(function () {
    validateValue(value);
    updateNumberState(value.value);
  }, [value]);

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(function () {
    return value && value.value ? value.value : '';
  }),
      _useState2 = _slicedToArray(_useState, 2),
      numberState = _useState2[0],
      updateNumberState = _useState2[1];

  var _useState3 = (0, _react.useState)({
    errors: [],
    warnings: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      validationState = _useState4[0],
      updateValidationState = _useState4[1];

  (0, _react.useEffect)(function () {
    var validValues = attribute ? attribute.values : null;
    var validationResult = (0, _numberValidators.validateNumber)(numberState, validValues, enforceValidValues);
    updateValidationState(validationResult);
  }, [numberState, attribute, enforceValidValues]);

  var onTextChanged = function onTextChanged(_ref2) {
    var value = _ref2.target.value;
    updateNumberState(value);
  };

  var onBlur = function onBlur() {
    var updatedValue = {
      type: _options.VALUE,
      value: validationState.numberString
    };
    onValueChanged(updatedValue);
  };

  return value ?
  /*#__PURE__*/
  _react["default"].createElement(_react["default"].Fragment, null, attribute ?
  /*#__PURE__*/
  _react["default"].createElement(_ValidValuesHeader.ValidValuesHeader, {
    attribute: attribute
  }) : null,
  /*#__PURE__*/
  _react["default"].createElement(_TextField["default"], {
    label: formatMessage(_messages["default"].enterNumber),
    value: validationState.numberString,
    onChange: onTextChanged,
    onBlur: onBlur,
    "data-testid": 'NumberInput'
  }),
  /*#__PURE__*/
  _react["default"].createElement(_ValidationResultDisplay.ValidationResultDisplay, {
    errors: validationState.errors,
    warnings: validationState.warnings
  })) : null;
};

exports.NumberValueEditor = NumberValueEditor;
NumberValueEditor.propTypes = {
  value: _propTypes["default"].shape(_propTypes2.valueShape),
  attribute: _propTypes["default"].shape(_propTypes2.atttributeShape),
  onValueChanged: _propTypes["default"].func.isRequired,
  enforceValidValues: _propTypes["default"].bool
};
NumberValueEditor.defaultProps = {
  value: {
    type: _options.VALUE
  },
  enforceValidValues: false
};